// plugins/online-sync.client.ts

import { defineNuxtPlugin } from "#app";
import { useSyncSales } from "@/composables/useSyncSales";

export default defineNuxtPlugin(() => {
  const { syncOfflineSales } = useSyncSales();

  window.addEventListener("online", () => {
    console.log("🌐 Internet reconnected.");
    syncOfflineSales();
  });
});
